import React, { useContext, useEffect, useState } from "react"
import InputFieldWithCurrency from "~/components/Admin/Inputs/InputFieldWithCurrency"
import { AdminContext } from "~/contexts/AdminContext"
import classNames from "~/utils/classNames"

const PartialPaymentInput = ({
  isDeposit,
  amountOwed,
  setAmountOwed,
  maxValue,
  setIsActive,
  isActive,
}: {
  isDeposit: boolean
  amountOwed: string
  setAmountOwed: React.Dispatch<React.SetStateAction<string>>
  maxValue: number
  setIsActive: React.Dispatch<React.SetStateAction<boolean>>
  isActive: boolean
}) => {
  const { camp } = useContext(AdminContext)

  useEffect(() => {
    if (isActive) {
      setAmountOwed(
        maxValue
          ? maxValue.toFixed(2)
          : amountOwed
      )
    } else {
      setAmountOwed(amountOwed)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isActive])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const rawValue = e.target.value

    if (/^(|[0-9]*\.?[0-9]*)$/.test(rawValue)) {
      if (rawValue === "" || rawValue === ".") {
        setAmountOwed(rawValue)
        return
      }
      const parsedValue = parseFloat(rawValue)
      const max = maxValue

      if (!isNaN(parsedValue) && parsedValue >= 0) {
        const clampedValue = Math.min(parsedValue, max)
        setAmountOwed(Number(rawValue) > clampedValue ? clampedValue.toFixed(2) : rawValue)
      }
    }
  }

  return (
    <div className="mb-4">
      <div className="mb-1 flex justify-between items-center mt-4 whitespace-nowrap">
        <label
          htmlFor="name"
          className={classNames("inline mr-2 font-bold text-md text-gray-900", !isActive && "hidden")}
        >
          {isDeposit ? "Deposit" : "Partial"} amount
        </label>
        <span
          className="inline underline text-sm text-gray-400 hover:text-gray-500 cursor-pointer"
          onClick={() => setIsActive(!isActive)}
        >
          {isActive ? "Remove" : "Take partial payment"}
        </span>
      </div>
      {isActive && (
        <InputFieldWithCurrency
          value={amountOwed}
          onChange={handleChange}
          name={isDeposit ? "deposit_subtotal_amount" : "charge_subtotal_amount"}
          currency={camp.currency}
          max={maxValue}
          min={0}
          type="text"
        />
      )}
    </div>
  )
}

export default PartialPaymentInput
